<template>
    <div>
        <el-dialog
            :title="dataTypes.course[0].courseArticleName"
            :visible.sync="ArticlePopup"
            width="300px"
            :modal="false"
            custom-class="couceClass"
            :showClose="false"
            :close-on-click-modal="false"
            center>
                <p>
                    <span>作者：</span>{{ dataTypes.course[0].author }}
                </p>
                
                <p>
                    <span>字数：</span>{{ dataTypes.course[0].number }}字
                </p>
               
                <span slot="footer" class="dialog-footer">
                    <button class="confirmButton"  @click="artciClick()">确定</button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:['dataTypes','ArticlePopup'],
    data() {
        return {
            
        }
    },
    methods: {
        artciClick(){
            this.$emit("choiceQuestion",false)//emit是固定的方法，发布、发表的意思
        }
    },
}
</script>

<style lang="scss" scoped>
    ::v-deep .couceClass{
        display: flex;
        display: -ms-flex; /* 兼容IE */
        flex-direction: column;
        -ms-flex-direction: column; /* 兼容IE */
        margin:0 !important;
        border-radius: 20px !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        max-height:calc(100% - 30px);
        max-width:calc(100% - 30px);
        .el-dialog__title{
            color: #000000;
        }
        .el-dialog .el-dialog__body{
            max-height: 100%;
            flex: 1;
            -ms-flex: 1 1 auto; /* 兼容IE */
            overflow-y: auto;
            overflow-x: hidden;
            text-align: center;
            font-size: 18px;
        }
        .confirmButton{
            width: 193px;
            height: 50px;
            border: none;
            border-radius: 30px;
            color: #FFFFFF;
            font-size: 18px;
            background: linear-gradient(to right, #2D85FF,#2DA5FF, #2DBEFF);
        }
   }
</style>